import { render, staticRenderFns } from "./wksp.vue?vue&type=template&id=f3b7c8ee&scoped=true"
import script from "./wksp.vue?vue&type=script&lang=js"
export * from "./wksp.vue?vue&type=script&lang=js"
import style0 from "./wksp.vue?vue&type=style&index=0&id=f3b7c8ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b7c8ee",
  null
  
)

export default component.exports